import get from 'lodash.get';
import { MappedRelative } from '../cancer-history-review/helper';
import { flatten } from '../../../helpers/relative';

export interface CancerHistories {
  relatives: {
    [key: string]: MappedRelative[];
  };
}

const splitRelativesFromRelativeKey = (relative: string) => {
  return relative.split('.').slice(1).join('.');
};

export const removeEmptyRelative = (cancerHistory: CancerHistories, baseKey: string, onResponseUpdated: (answerKey: string, val: any) => void) => {
  const updatedCancerHistory = Object.fromEntries(Object.entries(cancerHistory.relatives).filter(([_, value]) => (value as []).length > 0));
  onResponseUpdated(`${baseKey}.relatives`, updatedCancerHistory);
};

export const removeEmptyArraysFromCancerHistory = (
  relative: string,
  responses: any,
  baseKey: string,
  onResponseUpdated: (answerKey: string, val: any) => void,
) => {
  const flattenedRelative = relative.includes('maternal') || relative.includes('paternal') ? flatten(relative) : relative;
  const relativeKey = splitRelativesFromRelativeKey(flattenedRelative);
  const cancerHistory: CancerHistories = get(responses, baseKey, []);
  let updatedCancerHistory = { ...cancerHistory };
  const filteredRelatives = cancerHistory.relatives[relativeKey].filter((p: any) => p.pathology.length !== 0);

  updatedCancerHistory = {
    ...cancerHistory,
    relatives: {
      ...cancerHistory.relatives,
      [relativeKey]: filteredRelatives,
    },
  };

  if (filteredRelatives.length === 0) {
    updatedCancerHistory = {
      relatives: Object.fromEntries(Object.entries(updatedCancerHistory.relatives).filter(([_, value]) => (value as []).length > 0)),
    };
  }

  if (Object.keys(updatedCancerHistory.relatives).length === 0) {
    onResponseUpdated(baseKey, null);
  } else {
    onResponseUpdated(baseKey, updatedCancerHistory);
  }
};
